module.exports = __webpack_public_path__ + "img/bogo-eoas-02.e8148104.svg";